module.exports = __webpack_public_path__ + "img/mud-bricks.2672b80d.webp";